export const CHECKOUT_URL = 'https://tuversionelevada.com/cart/53233568842025:1'

export function goToCheckout() {
  window.location.href = CHECKOUT_URL
}
